/**
 * 实体管理所用的地图，支持在地图上标记一个实体（企业）的位置，也可以重新编辑这个标记的位置
 */
import BMapProxy from '@/common/BMapProxy.js'
import {
  parkPostionAdd
} from '@/api/park.js'


function Map() {
  var map
  var view
  var activeOutline

  var overOutline
  var outline

  /**
   *
   * @param {String} container
   */
  this.init = function (container, flag, landData) {
    const proxy = new BMapProxy()
    proxy.init(container, 2).then((m, v) => {
      map = m
      view = v
      // map.setMapType(BMAP_EARTH_MAP)
      proxy.fly2(117.17425174628049, 32.48339622720056, 13).then(() => {
        if (flag == false) {
          var scaleCtrl = new BMapGL.ScaleControl() // 添加比例尺控件
          map.addControl(scaleCtrl)
          if (landData.position != null) {
            this.initdrawing(map, landData)
          }
          //  this.drawing(map,landData)
        } else {
          if (landData.length != 0) {

            this.drawPark(map, landData)
          }
        }
        console.log('地图加载完成！', map.getBounds())
      })
    })
  }
  //初始化原有的地图位置
  this.initdrawing = function (map, landData) {
    var array = []
    let land = landData.position
    land.forEach(element => {
        array.push(new BMapGL.Point(element.lng, element.lat))
      }),
      outline = new BMapGL.Polygon(
        array, {
          strokeColor: 'blue',
          strokeWeight: 2,
          strokeOpacity: 0.5
        })
    map.centerAndZoom(new BMapGL.Point(landData.lng, landData.lat), 13)
    map.addOverlay(outline)
    outline.enableEditing()
    overOutline = outline

    // })

  }
  //画地块点击事件
  this.drawing = function (map, landData) {

    map.addEventListener('click', function (e) {
      console.log('点击位置经纬度：', e.latlng.lng, e.latlng.lat)
      const {
        width,
        height
      } = map.getBounds().toSpan()
      // const {
      let lng = e.latlng.lng
      let lat = e.latlng.lat
      // } = map.getCenter()
      outline = new BMapGL.Polygon([
        new BMapGL.Point(lng - width * 0.2, lat + height * 0.2),
        new BMapGL.Point(lng + width * 0.2, lat + height * 0.2),
        new BMapGL.Point(lng + width * 0.2, lat - height * 0.2),
        new BMapGL.Point(lng - width * 0.2, lat - height * 0.2)
      ], {
        strokeColor: 'blue',
        strokeWeight: 2,
        strokeOpacity: 0.5
      })
      console.log(outline.points)
      map.removeOverlay(overOutline)
      map.addOverlay(outline)
      outline.enableEditing()
      overOutline = outline
      // console.log(  map.getOverlays()[0].points)
      console.log("444")

    })
  }

  //园区初始化地图
  this.drawPark = function (map, landData) {
    landData.forEach(p => {
      var array = []
      let land = p.position
      if (land == null) {
        return
      }
      console.log("777", p)
      console.log("666", p.lng, p.lat)
      console.log("666", p.name)
      var marker = new BMapGL.Marker(new BMapGL.Point(p.lng, p.lat))
      var marker = new BMapGL.Marker(new BMapGL.Point(p.lng, p.lat))

      var label = new BMapGL.Label(p.name, {
        offset: new BMapGL.Size(10, -25)
      })
      label.setStyle({
        display: "block",
        color: "red",
        fontSize: "12px",
        height: "20px",
        lineHeight: "20px",
        fontFamily: "微软雅黑"
      })
      marker.setLabel(label)
      map.addOverlay(marker)

      land.forEach(element => {
          array.push(new BMapGL.Point(element.lng, element.lat))
        }),
        outline = new BMapGL.Polygon(

          array, {
            strokeColor: 'blue',
            strokeWeight: 2,
            strokeOpacity: 0.5
          })
      // console.log(outline.points)
      // outline.setLabel(lable)
      map.addOverlay(outline)

    })
  }
  this.drawOutline = function () {
    const {
      sw,
      ne
    } = map.getBounds()
    const lng = (sw.lng + ne.lng) / 2
    const lat = (sw.lat + ne.lat) / 2
    const {
      width,
      height
    } = map.getBounds().toSpan()
    outline = new BMapGL.Polygon([
      new BMapGL.Point(lng - width * 0.2, lat + height * 0.2),
      new BMapGL.Point(lng + width * 0.2, lat + height * 0.2),
      new BMapGL.Point(lng + width * 0.2, lat - height * 0.2),
      new BMapGL.Point(lng - width * 0.2, lat - height * 0.2)
    ], {
      strokeColor: 'blue',
      strokeWeight: 4,
      strokeOpacity: 0.5
    })
    map.addOverlay(outline)
    outline.enableEditing()
  }
  //获取保存的地块边界数据
  this.getPosition = function () {

    let point = outline.getBounds()

    let centerx = (point.maxX + point.minX) / 2
    let centerY = (point.maxY + point.minY) / 2
    let array = [outline.getPath(), centerx, centerY]
    return array
  }
  //  /**
  //    * 保存数据
  //    *
  //    */
  // this.getPosition  = function(){
  //   if(newPoint==undefined){
  //     alert("请在地图上选择园区位置")
  //   }else{
  //       return   newPoint
  //   }
  // }
  /**
   * 在地图上放置一个临时的区域轮廓，这个轮廓是以当前视口范围为基础略微收缩一点。
   * 这用于给还未设置任何轮廓数据的园区新设置一个初始的轮廓。
   */
  this.putActiveOutline = function () {
    if (activeOutline) {
      // 如果已经存在临时轮廓则返回（同一时间只能存在一个临时轮廓）
      return
    }
    const {
      width,
      height
    } = map.getBounds().toSpan()
    const {
      lng,
      lat
    } = map.getCenter()
    activeOutline = new BMapGL.Polygon([
      new BMapGL.Point(lng - width * 0.4, lat + height * 0.4),
      new BMapGL.Point(lng + width * 0.4, lat + height * 0.4),
      new BMapGL.Point(lng + width * 0.4, lat - height * 0.4),
      new BMapGL.Point(lng - width * 0.4, lat - height * 0.4)
    ], {
      strokeColor: 'blue',
      strokeWeight: 2,
      strokeOpacity: 0.5
    })
    map.addOverlay(activeOutline)
    activeOutline.enableEditing()
  }

  /**
   * 移除临时区域轮廓（如果存在的话）
   */
  this.removeActiveOutline = function () {
    if (!activeOutline) {
      return
    }
    map.removeOverlay(activeOutline)
  }

  /**
   * 读取当前临时轮廓，返回geosjon数据
   * @returns 当前轮廓的标准geojson数据
   */
  this.getActiveOutline = function () {
    if (!activeOutline) {
      return
    }
    const points = []
    const path = activeOutline.getPath()
    path.forEach(p => {
      points.push([p.lng, p.lat])
    })
    return {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [points]
      }
    }
  }
  this.destroy = function () {
    if (map && map.destroy)
      map.destroy()
  }

}
//园区数据
const jsonSample = {
  data: [{
      id: 407,
      lng: 117.17425174628049,
      lat: 32.48339622720056,
      markers: "园区1号"
    },
    {
      id: 407,
      lng: 117.17425174628049,
      lat: 32.4,
      markers: "园区2号"
    }
  ]

}
export default new Map()



// WEBPACK FOOTER //
// ./src/components/meta/park/map.js